var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlipToLandscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-flip-to-landscape",
    transform: "translate(-678.268 -713.166)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10718",
    "data-name": "Ellipse 10718",
    cx: 88,
    cy: 88,
    r: 88,
    transform: "translate(678.268 713.166)",
    fill: "#222e5b",
    opacity: 0.502,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile-point-3",
    transform: "translate(1568.101 33.451) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197964",
    "data-name": "Path 197964",
    d: "M787.616,856.252H747.033a9.92,9.92,0,0,1-9.909-9.909V755.208a9.92,9.92,0,0,1,9.909-9.908h40.583a9.92,9.92,0,0,1,9.909,9.908v91.135a9.92,9.92,0,0,1-9.909,9.909m-40.583-106.8a5.761,5.761,0,0,0-5.755,5.755v91.135a5.761,5.761,0,0,0,5.755,5.756h40.583a5.762,5.762,0,0,0,5.756-5.756V755.208a5.762,5.762,0,0,0-5.756-5.755Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197965",
    "data-name": "Path 197965",
    d: "M779.483,754.679H757.621a1.233,1.233,0,0,1-1.233-1.232V753.3a1.233,1.233,0,0,1,1.233-1.232h21.862a1.233,1.233,0,0,1,1.232,1.232v.149a1.233,1.233,0,0,1-1.232,1.232",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mobile-point-2",
    transform: "translate(790.979 -308.038) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197964-2",
    "data-name": "Path 197964",
    d: "M787.616,856.252H747.033a9.92,9.92,0,0,1-9.909-9.909V755.208a9.92,9.92,0,0,1,9.909-9.908h40.583a9.92,9.92,0,0,1,9.909,9.908v91.135a9.92,9.92,0,0,1-9.909,9.909m-40.583-106.8a5.761,5.761,0,0,0-5.755,5.755v91.135a5.761,5.761,0,0,0,5.755,5.756h40.583a5.762,5.762,0,0,0,5.756-5.756V755.208a5.762,5.762,0,0,0-5.756-5.755Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197965-2",
    "data-name": "Path 197965",
    d: "M779.483,754.679H757.621a1.233,1.233,0,0,1-1.233-1.232V753.3a1.233,1.233,0,0,1,1.233-1.232h21.862a1.233,1.233,0,0,1,1.232,1.232v.149a1.233,1.233,0,0,1-1.232,1.232",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "mobile-point-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197964-3",
    "data-name": "Path 197964",
    d: "M787.616,856.252H747.033a9.92,9.92,0,0,1-9.909-9.909V755.208a9.92,9.92,0,0,1,9.909-9.908h40.583a9.92,9.92,0,0,1,9.909,9.908v91.135a9.92,9.92,0,0,1-9.909,9.909m-40.583-106.8a5.761,5.761,0,0,0-5.755,5.755v91.135a5.761,5.761,0,0,0,5.755,5.756h40.583a5.762,5.762,0,0,0,5.756-5.756V755.208a5.762,5.762,0,0,0-5.756-5.755Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197965-3",
    "data-name": "Path 197965",
    d: "M779.483,754.679H757.621a1.233,1.233,0,0,1-1.233-1.232V753.3a1.233,1.233,0,0,1,1.233-1.232h21.862a1.233,1.233,0,0,1,1.232,1.232v.149a1.233,1.233,0,0,1-1.232,1.232",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197966",
    "data-name": "Path 197966",
    d: "M836.668,802.666a1.5,1.5,0,0,1-1.5-1.5,68.977,68.977,0,0,0-68.9-68.9,1.5,1.5,0,0,1,0-3,71.981,71.981,0,0,1,71.9,71.9A1.5,1.5,0,0,1,836.668,802.666Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197967",
    "data-name": "Path 197967",
    d: "M836.668,802.666a1.5,1.5,0,0,1-1.136-.521L827,792.236a1.5,1.5,0,1,1,2.273-1.957l7.152,8.309,5.826-10.064a1.5,1.5,0,0,1,2.6,1.5l-6.884,11.89a1.5,1.5,0,0,1-1.159.741A1.324,1.324,0,0,1,836.668,802.666Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlipToLandscape);
export default __webpack_public_path__ + "static/media/icon-flip-to-landscape.761235f01d52773d9e3b99bf4a550aea.svg";
export { ForwardRef as ReactComponent };